import QueueContext, { Queue } from '../context/QueueContext'
import { useContext } from 'react'

export function useQueue(): Queue {
    return useContext(QueueContext)
}
